import React from "react";
import { Card, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

export default function Comments(props) {
  const {item, user, deleteClickHandler} = props;
  function setReadableDate(date) {
    const readableDate = new Date(date);
    return readableDate.toDateString();
  }
  return (
    <Card>
      <Link to="" className="ms-3">{item.author.first_name + " " + item.author.last_name}</Link>
      <Card.Body>{item.body}</Card.Body>
      <small>{setReadableDate(item.createdAt)}</small>
      {item.author.id === (user._id || user.id) && <Button onClick={() => deleteClickHandler(item.id)} variant="outline-danger">Delete Comment</Button>}
    </Card>
  );
}
